/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coinvestments_Report_Stillactive_Closedateline4Inputs */

const en_coinvestments_report_stillactive_closedateline4 = /** @type {(inputs: Coinvestments_Report_Stillactive_Closedateline4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`<br/>The current close date is ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "<br/>The current close date is {date}." |
*
* @param {Coinvestments_Report_Stillactive_Closedateline4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_stillactive_closedateline4 = /** @type {((inputs: Coinvestments_Report_Stillactive_Closedateline4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Stillactive_Closedateline4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_stillactive_closedateline4(inputs)
});
export { coinvestments_report_stillactive_closedateline4 as "coInvestments_report_stillActive_closeDateLine" }